import operationReportService from "@/services/operations/operationReportService";
import mapKeys from "lodash/mapKeys.js";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isNumber from "lodash/isNumber";
import operationWorkflowService from "@/services/operations/operationWorkflowService";
import enterpriseWorkflowService from "@/services/enterprises/enterpriseWorkflowService";
import Vue from "vue";
import * as operationUtils from "@/utils/operations";

// NOTE: マスタデータではない。詳細などで使用する単一のレポートのデータを管理する
const INITIAL_STATE = {
  operationReport: {
    //   "ao_enterprise_vessel_report_form_versions": [
    //     {
    //       "ao_enterprise_vessel_report_form_version_items": [
    //         {
    //           "ao_enterprise_vessel_report_form_version_id": "string",
    //           "form_version_item_id": "string",
    //           "id": "string",
    //           "value_date": "string",
    //           "value_date_time": "2024-03-22T11:46:36.817Z",
    //           "value_number": 0,
    //           "value_string": "string",
    //           "value_time": "string"
    //           "nullable_checked": true,
    //         }
    //       ],
    //       "form_version_id": "string",
    //       "id": "string"
    //     }
    //   ],
    //   "ao_enterprise_workflow_vessel_id": "string",
    //   "created_at": "2024-03-22T11:46:36.817Z",
    //   "hash": "string",
    //   "id": "string",
    //   "updated_at": "2024-03-22T11:46:36.817Z",
    //   "version": 0,
    //   "workflow_status_id": "string"
  }, // : AoEnterpriseVesselReport
};

export default {
  isRegistered: false,
  namespaced: true,

  state: {
    ...INITIAL_STATE,
  },

  mutations: {
    SET_OPERATION_REPORT(state, data) {
      state.operationReport = data;
    },

    SET_FORM_VERSION_ITEM_VALUE(
      state,
      payload // {
      // formVersionSortOrder: number;
      //        {
      //           "form_version_item_id": `${number}`,
      //           "nullable_checked": boolean | null,
      //           "value_date": string | null; "2024-04-18"
      //           "value_date_time": string | null; "2024-04-18T05:00:21.564Z"
      //           "value_files": [
      //             {
      //               "name": string | null; // NOTE: 一時ファイルを作成しておく必要がある
      //             }
      //           ],
      //           "value_number": number;
      //           "value_string": string | null;
      //           "value_time": string | null; "05:00:21"
      //         }
      // }
    ) {
      const { formVersionSortOrder, ...rest } = payload;
      const { form_version_item_id: formVersionItemId } = rest;
      const aoEnterpriseVesselReportFormVersion =
        state.operationReport.ao_enterprise_vessel_report_form_versions[
          formVersionSortOrder
        ];
      const aoEnterpriseVesselReportFormVersionItems =
        aoEnterpriseVesselReportFormVersion.ao_enterprise_vessel_report_form_version_items;
      const formVersionItemSortOrder = aoEnterpriseVesselReportFormVersionItems.findIndex(
        reportFormVersionItem =>
          reportFormVersionItem.form_version_item_id === formVersionItemId
      );
      const current =
        aoEnterpriseVesselReportFormVersionItems[formVersionItemSortOrder];
      const nextFormVersionItem = {
        value_string: null,
        value_number: null,
        value_date: null,
        value_time: null,
        value_date_time: null,
        value_files: null,
        nullable_checked: false,
        ao_enterprise_vessel_report_form_version_id:
          aoEnterpriseVesselReportFormVersion.id,
        form_version_item_id: formVersionItemId,
        ...current,
        ...rest,
      };
      if (!current) {
        // 新規作成
        aoEnterpriseVesselReportFormVersionItems.push(nextFormVersionItem);
      } else {
        // 更新
        Vue.set(
          aoEnterpriseVesselReportFormVersionItems,
          formVersionItemSortOrder,
          nextFormVersionItem
        ); // 変更をリアクティブに反映
      }
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },

  actions: {
    /**
     * operation report をstoreにセットする
     *
     * @returns {Promise<Object>}
     * @property {boolean} status - APIのリクエストが成功したかどうか
     * @property {number} code - ステータスコード
     * @property {AoEnterpriseVesselReport} data - データ
     * @property {string} message - メッセージ
     * @throws {Error}
     */

    async setOperationReport(
      { commit },
      payload // { aoEnterpriseId: string, reportId: string }
    ) {
      const operationReport = await operationReportService.getOperationReport(
        payload
      );
      commit("SET_OPERATION_REPORT", operationReport.data || {});
      return operationReport;
    },

    /**
     * Deletes an operation report.
     *
     * @param {any} _ - The placeholder parameter.
     * @param {Object} payload - The payload object containing the enterprise ID and report ID.
     * @param {string} payload.aoEnterpriseId - The ID of the enterprise.
     * @param {string} payload.reportId - The ID of the report.
     * @returns {Promise<Object>}
     * @property {boolean} status - APIのリクエストが成功したかどうか
     * @property {number} code - ステータスコード
     * @property {AoEnterpriseVesselReport} data - データ
     * @property {string} message - メッセージ
     * @throws {Error} - レスポンスが帰ってこない場合にエラーをスロー
     */
    async deleteOperationReport(
      _,
      payload // { aoEnterpriseId: string, reportId: string }
    ) {
      return await operationReportService.deleteOperationReport(payload);
    },

    /**
     * Deletes current operation report.
     *
     * @param {context} context - The context of the action
     * @returns {Promise<Object>}
     * @property {boolean} status - APIのリクエストが成功したかどうか
     * @property {number} code - ステータスコード
     * @property {AoEnterpriseVesselReport} data - データ
     * @property {string} message - メッセージ
     * @throws {Error} - レスポンスが帰ってこない場合にエラーをスロー
     */
    async deleteCurrentOperationReport({ dispatch, getters }) {
      return await dispatch(
        "deleteOperationReport",
        getters.routeParamOfCurrentReport // like { aoEnterpriseId: "1111", reportId: "111111111" }
      );
    },

    // レポートを更新する
    async updateCurrentOperationReport({ getters }) {
      const {
        reportAoEnterpriseId: aoEnterpriseId,
        reportId,
        updateBody,
      } = getters;
      return await operationReportService.updateReport(
        { aoEnterpriseId, reportId },
        updateBody
      );
    },

    /**
     * execute transaction of an operation report.
     *
     * @param {any} _ - The placeholder parameter.
     * @param {Object} payload - The payload object containing the enterprise ID and report ID.
     * @param {string} payload.aoEnterpriseId - The ID of the enterprise.
     * @param {string} payload.reportId - The ID of the report.
     * @param {string} payload.transactionId - The ID of the transaction.
     * @param {number} payload.version - The version of the report.
     * @returns {Promise<Object>}
     * @property {boolean} status - APIのリクエストが成功したかどうか
     * @property {number} code - ステータスコード
     * @property {AoEnterpriseVesselReport} data - データ
     * @property {string} message - メッセージ
     * @throws {Error} - レスポンスが帰ってこない場合にエラーをスロー
     */
    async transactionOperationReport(
      _,
      payload // {aoEnterpriseId: string; reportId: string; transactionId: string; version: number;}
    ) {
      const { version } = payload;
      return await operationReportService.transactionOperationReport(payload, {
        version,
      });
    },

    /**
     * execute transaction of current operation report.
     *
     * @param {any} _ - The placeholder parameter.
     * @param {Object} payload - The payload object containing the enterprise ID and report ID.
     * @param {string} payload.transactionId - The ID of the transaction.
     * @returns {Promise<Object>}
     * @property {boolean} status - APIのリクエストが成功したかどうか
     * @property {number} code - ステータスコード
     * @property {AoEnterpriseVesselReport} data - データ
     * @property {string} message - メッセージ
     * @throws {Error} - レスポンスが帰ってこない場合にエラーをスロー
     */
    async transactionCurrentOperationReport(
      { dispatch, getters },
      payload // {transactionId: string;}
    ) {
      const { transactionId } = payload;
      const transactionPayload = {
        ...getters.routeParamOfCurrentReport,
        transactionId,
        version: getters.reportVersion,
      }; // like {
      //   aoEnterpriseId: "1111",
      //   reportId: "111111111",
      //   transactionId: "111111111",
      //   version: 9999,
      // }
      return await dispatch("transactionOperationReport", transactionPayload);
    },

    /**
     * Uploads temporary files.
     *
     * @param {Object} _ - The placeholder parameter.
     * @param {Object} payload - The payload object containing the following properties:
     *   @param {string} payload.aoEnterpriseId - The ID of the enterprise.
     *   @param {string} payload.hash - The hash value.
     *   @param {FormData} payload.formData - The FormData object containing the files to be uploaded.
     * @returns {Promise} A promise that resolves with the result of the file upload.
     * @throws {Error} - レスポンスが帰ってこない場合・引数に問題がある場合にエラーをスロー
     */
    async uploadTempFiles(
      _,
      payload
      // {
      //   aoEnterpriseId: string; reportId: string; hash: string;
      //   formData: FormData;
      // }
    ) {
      const { formData, ...routeParams } = payload;
      return await operationReportService.uploadTempFiles(
        routeParams,
        formData
      );
    },

    // 現在のレポートの一時ファイルを作成する
    async uploadTempFilesOfCurrentFile(
      { dispatch, getters },
      payload
      // {
      //   formData: FormData;
      //   formVersionItemId: string;
      // }
    ) {
      const { reportAoEnterpriseId: aoEnterpriseId, reportId } = getters;
      const { formData, formVersionItemId } = payload;
      const hash = operationUtils.createOperationHash(
        `${aoEnterpriseId}-${reportId}-${formVersionItemId}`
      );
      return await dispatch("uploadTempFiles", {
        aoEnterpriseId,
        reportId,
        hash,
        formData,
      });
    },

    setFormVersionItemValue(
      { commit, _getters },
      payload // {
      // formVersionSortOrder: number;
      //        {
      //           "form_version_item_id": `${number}`,
      //           "nullable_checked": boolean | null,
      //           "value_date": string | null; "2024-04-18"
      //           "value_date_time": string | null; "2024-04-18T05:00:21.564Z"
      //           "value_files": [
      //             {
      //               "name": string | null; // NOTE: 一時ファイルを作成しておく必要がある
      //             }
      //           ],
      //           "value_number": number;
      //           "value_string": string | null;
      //           "value_time": string | null; "05:00:21"
      //         }
      // }
    ) {
      commit("SET_FORM_VERSION_ITEM_VALUE", payload); // TODO:
    },

    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },

  getters: {
    // 更新に使用するパラメータ
    updateBody: (_, { operationReport }) => {
      return operationReport;
    },

    operationReport: state => state.operationReport,

    isEnterpriseVesselReportValid: (_, { operationReport }) => {
      return operationReportService.isValidAoEnterpriseVesselReport(
        operationReport
      );
    },

    // 現在のレポートを削除するためのパラメータ
    routeParamOfCurrentReport(_, { reportId, reportAoEnterpriseId }) {
      return {
        aoEnterpriseId: reportAoEnterpriseId,
        reportId,
      }; // { aoEnterpriseId: string, reportId: string }
    },

    // レポート名
    reportOperation: (
      _state,
      { isEnterpriseVesselReportValid, reportAoEnterpriseId },
      _rootState,
      rootGetters
    ) => {
      if (!isEnterpriseVesselReportValid) return undefined;
      if (!reportAoEnterpriseId) return undefined;
      return rootGetters["operations/operationMap"][reportAoEnterpriseId]; // undefined | operation
    },

    reportOperationService(_state, { reportOperation }) {
      if (!isObject(reportOperation)) return "";
      if (!isString(reportOperation.name)) return "";
      return reportOperation.name;
    },

    reportOperationWorkflowVesselId: (
      _,
      { operationReport, isEnterpriseVesselReportValid }
    ) => {
      if (!isEnterpriseVesselReportValid) return null;
      return operationReport.ao_enterprise_workflow_vessel_id;
    },

    // NOTE: レポートに紐づくworkflowStatusId(operationWorkflowStatusのものではなく、マスタのもの)
    reportWorkflowStatusId: (
      _,
      { operationReport, isEnterpriseVesselReportValid }
    ) => {
      if (!isEnterpriseVesselReportValid) return null;
      return operationReport.workflow_status_id;
    },

    // NOTE: レポートの現在のworkflowStatus(operationWorkflowStatusのものではなく、マスタのもの)
    // EnterpriseWorkflowStatus | {}
    reportWorkflowStatus: (
      _state,
      { reportWorkflowStatusId },
      _rootState,
      rootGetters
    ) => {
      if (!reportWorkflowStatusId) return {};
      return (
        rootGetters["enterpriseWorkflows/workflowStatusMap"][
          reportWorkflowStatusId
        ] || {}
      );
    },

    // NOTE: レポートに紐づくworkflow(operationWorkflowではなく、マスタのもの)が日もづくworkflowのマスタ
    // EnterpriseWorkflow | {}
    reportWorkflow: (
      _state,
      { reportWorkflowStatusId },
      _rootState,
      rootGetters
    ) => {
      if (!reportWorkflowStatusId) return {};
      return (
        rootGetters["enterpriseWorkflows/workflowMapByWorkflowStatusId"][
          reportWorkflowStatusId
        ] || {}
      );
    },

    // 詳細に表示する進捗バーのデータ
    // レポートに紐づくworkflowのマスタに、紐づいているworkflowStatusのマスタのリスト
    reportWorkflowStatuses: (
      _state,
      { reportWorkflow },
      _rootState,
      _rootGetters
    ) => {
      if (!Array.isArray(reportWorkflow.workflow_statuses)) return [];
      return reportWorkflow.workflow_statuses;
    },

    // レポートに紐づくworkflowのマスタに、紐づいているworkflowWorkflowのマスタのリスト
    reportWorkflowTransactions: (
      _state,
      { reportWorkflow },
      _rootState,
      _rootGetters
    ) => {
      if (!Array.isArray(reportWorkflow.workflow_transactions)) return [];
      return reportWorkflow.workflow_transactions;
    },

    reportOperationWorkflowVessel: (
      _state,
      { isEnterpriseVesselReportValid, reportOperationWorkflowVesselId },
      _rootState,
      rootGetters
    ) => {
      if (!isEnterpriseVesselReportValid) return undefined;
      return rootGetters["operationWorkflows/operationWorkflowVesselMap"][
        reportOperationWorkflowVesselId
      ];
    },

    reportEnterpriseVesselId: (
      _state,
      { reportOperationWorkflowVessel },
      _rootState,
      _rootGetters
    ) => {
      if (!isObject(reportOperationWorkflowVessel)) return "";
      return reportOperationWorkflowVessel.enterprise_vessel_id;
    },

    reportEnterpriseVessel: (
      _state,
      { reportEnterpriseVesselId },
      _rootState,
      rootGetters
    ) => {
      return (
        rootGetters["operationVessels/operationVesselMapByEnterpriseVesselId"][
          reportEnterpriseVesselId
        ] || {}
      );
    },

    // NOTE: [Operationワークフロー設定]
    // マスタのworkflowではない
    //  色々使う
    reportOperationWorkflow: (
      _state,
      { isEnterpriseVesselReportValid, reportOperationWorkflowVesselId },
      _rootState,
      rootGetters
    ) => {
      if (!isEnterpriseVesselReportValid) return undefined;
      return rootGetters[
        "operationWorkflows/operationWorkflowMapByAoEnterpriseWorkflowVesselId"
      ][reportOperationWorkflowVesselId];
    },

    // ao_enterprise_workflow_vessel_accounts
    reportOperationWorkflowVesselAccounts: (_state, getters) => {
      const g = getters;
      if (!g.reportOperationWorkflowVessel) return [];
      return g.reportOperationWorkflowVessel
        .ao_enterprise_workflow_vessel_accounts;
    },

    reportOperationWorkflowVesselAccountMapByAccountId: (_state, getters) => {
      const g = getters;
      return mapKeys(g.reportOperationWorkflowVesselAccounts, "account_id"); // 一つの船舶に紐づく OperationWorkflowVesselAccount は account_id で一意になる
    },

    // 船舶の権限
    // NOTE: 最初にログインユーザのaccountIdをセットしておく必要がある
    // reportOperationWorkflowVesselAccountOfCurrentUser: (
    vesselPermissions: (_state, getters, _, rootGetters) => {
      return (
        getters.reportOperationWorkflowVesselAccountMapByAccountId[
          rootGetters["auth/accountId"]
        ] || {}
      );
    },

    vesselCreatable: (_, { vesselPermissions }) => {
      return vesselPermissions.creatable || false;
    },

    vesselUpdatable: (_, { vesselPermissions }) => {
      return vesselPermissions.updatable || false;
    },

    vesselDeletable: (_, { vesselPermissions }) => {
      return vesselPermissions.deletable || false;
    },

    // NOTE: 詳細とかに表示する時、起点になる
    // operationWorkflowForm[] のうち、レポートに紐づいているもの
    reportOperationWorkflowForms: (
      _state,
      { reportOperationWorkflow, reportEnterpriseFormMap }
    ) => {
      if (!isObject(reportOperationWorkflow)) return [];
      if (
        !Array.isArray(reportOperationWorkflow.ao_enterprise_workflow_forms)
      ) {
        return [];
      }
      return reportOperationWorkflow.ao_enterprise_workflow_forms
        .filter(owf => operationWorkflowService.isOperationWorkflowForm(owf))
        .filter(owf => reportEnterpriseFormMap[owf.form_id]);
    },

    reportAoEnterpriseId: (_state, { reportOperationWorkflow }, _rootState) => {
      if (!isObject(reportOperationWorkflow)) return undefined;
      return reportOperationWorkflow.ao_enterprise_id; // undefined | string
    },

    reportId: (_, { operationReport }) => {
      if (!isObject(operationReport)) return "";
      if (!isString(operationReport.id)) return "";
      return operationReport.id; // string
    },

    reportVersion: (_, { operationReport }) => {
      if (!isObject(operationReport)) return undefined;
      if (!isNumber(operationReport.version)) return undefined;
      return operationReport.version; // number
    },

    // 日付の表示に使う。フォーマットいる
    reportUpdatedAt: (
      _,
      { operationReport, isEnterpriseVesselReportValid }
    ) => {
      if (!isEnterpriseVesselReportValid) return "";
      return operationReport.updated_at; // like "2024-03-22T11:46:36.817Z"
    },

    // reportのoperationWorkflowに紐づくoperationWorkflowStatusのリスト
    reportOperationWorkflowStatuses: (
      _state,
      { reportOperationWorkflow },
      _rootState,
      _rootGetters
    ) => {
      if (!isObject(reportOperationWorkflow)) return [];
      if (
        !Array.isArray(reportOperationWorkflow.ao_enterprise_workflow_statuses)
      )
        return [];
      return reportOperationWorkflow.ao_enterprise_workflow_statuses.filter(
        operationWorkflowStatus =>
          operationWorkflowService.isResponseEnterpriseOperationWorkflowStatus(
            operationWorkflowStatus
          )
      );
    },

    // NOTE: レポートの現在のOperationWorkflowStatus
    // マスタのworkflowではない
    // reportのoperationWorkflowStatus | undefined
    reportOperationWorkflowStatus: (
      _state,
      getters,
      _rootState,
      _rootGetters
    ) => {
      return getters.reportOperationWorkflowStatuses.find(
        operationWorkflowStatus => {
          return (
            operationWorkflowStatus.workflow_status_id ===
            getters.reportWorkflowStatusId
          );
        }
      );
    },

    // NOTE: レポートの現在のStatusに紐づくWorkflowTransaction、に紐づくOperationWorkflowTransaction
    reportCurrentStatusOperationWorkflowTransactions: (
      _state,
      getters,
      _rootState,
      _rootGetters
    ) => {
      const g = getters;
      const reportOperationWorkflowTransactions =
        g.reportOperationWorkflow.ao_enterprise_workflow_transactions || [];
      const reportCurrentWorkflowStatusTransactionMap = mapKeys(
        g.reportCurrentWorkflowStatusTransactions,
        "id"
      );
      return reportOperationWorkflowTransactions.filter(
        operationWorkflowTransaction => {
          return reportCurrentWorkflowStatusTransactionMap[
            operationWorkflowTransaction.workflow_transaction_id
          ];
        }
      );
    },

    // NOTE: ログインユーザが現在のステータスで実行可能なworkflowTransactionのマスタの実行権限を持っているか確認するのに使用する
    // NOTE: 船の権限と合わせて使用する必要がある
    reportCurrentStatusOperationWorkflowTransactionPermissionMapByWorkflowTransactionId: (
      _state,
      getters,
      _rootState,
      rootGetters
    ) => {
      const g = getters;
      const permissionMapByWorkflowTransactionId = g.reportCurrentStatusOperationWorkflowTransactions.reduce(
        (acc, operationWorkflowTransaction) => {
          acc[
            operationWorkflowTransaction.workflow_transaction_id
          ] = operationWorkflowService.hasAccountOperationWorkflowTransactionPermission(
            operationWorkflowTransaction,
            rootGetters["auth/accountId"]
          );
          return acc;
        },
        {}
      );
      return permissionMapByWorkflowTransactionId;
    },

    // reportのoperationWorkflowStatusForm
    reportOperationWorkflowStatusForms: (
      _state,
      { reportOperationWorkflowStatus, reportOperationWorkflowForms }
    ) => {
      if (!reportOperationWorkflowStatus) return [];
      const reportOperationWorkflowFormMap = mapKeys(
        reportOperationWorkflowForms,
        "id"
      );

      return reportOperationWorkflowStatus.ao_enterprise_workflow_status_forms.filter(
        aoeWSF =>
          reportOperationWorkflowFormMap[aoeWSF.ao_enterprise_workflows_form_id]
      );
    },

    // reportの現在のステータスに日もづくoperationWorkflowStatusAccounts
    statusAccounts: (_state, { reportOperationWorkflowStatus }) => {
      if (!reportOperationWorkflowStatus) return [];

      return reportOperationWorkflowStatus.ao_enterprise_workflow_status_accounts.filter(
        aoeWSA =>
          operationWorkflowService.isResponseEnterpriseOperationWorkflowStatusAccount(
            aoeWSA
          )
      );
    },

    statusAccountOfCurrentUser: (
      _state,
      { statusAccounts },
      _,
      rootGetters
    ) => {
      return (
        statusAccounts.find(
          statusAccount =>
            statusAccount.account_id === rootGetters["auth/accountId"]
        ) || {}
      );
    },

    // currentUserのstatusAccountがdeletableかどうか
    // NOTE: 船舶のdeleteableと組み合わせる必要がある
    isStatusAccountDeletable: (_state, { statusAccountOfCurrentUser }, _) => {
      return statusAccountOfCurrentUser.deletable || false;
    },

    // statusAccountと船舶の権限を組み合わせて、レポートが削除可能かどうか
    isReportDeletable: (
      _state,
      { isStatusAccountDeletable, vesselDeletable },
      _
    ) => {
      return isStatusAccountDeletable && vesselDeletable;
    },

    // {[operationWorkflowFormId]: {[AccountId]: StatusFormAccount}}
    statusFormAccountOfCurrentUserMapByOperationWorkflowFormId: (
      _state,
      { reportOperationWorkflowStatusForms },
      _rootState,
      rootGetters
    ) => {
      return reportOperationWorkflowStatusForms.reduce((acc, statusForm) => {
        const statusFormAccounts =
          statusForm.ao_enterprise_workflow_status_form_accounts;
        const operationWorkflowFormId =
          statusForm.ao_enterprise_workflows_form_id;
        acc[operationWorkflowFormId] =
          mapKeys(statusFormAccounts, "account_id")[
            rootGetters["auth/accountId"]
          ] || {};
        // ao_enterprise_workflow_status_forms の一つのレコードに対して紐づく ao_enterprise_workflow_status_form_accounts は account_idで一意になる
        return acc;
      }, {});
    },

    // { [key: operationWorkflowFormId]: boolean }
    // 船舶の権限と組み合わせる必要がある
    statusFormAccountUpdatableMapByOperationWorkflowFormId: (
      _state,
      {
        reportOperationWorkflowForms,
        statusFormAccountOfCurrentUserMapByOperationWorkflowFormId,
      }
    ) => {
      return reportOperationWorkflowForms.reduce(
        (acc, operationWorkflowForm) => {
          const operationWorkflowFormId = operationWorkflowForm.id;
          const statusFormAccountOfCurrentUser =
            statusFormAccountOfCurrentUserMapByOperationWorkflowFormId[
              operationWorkflowFormId
            ];
          acc[operationWorkflowFormId] =
            (statusFormAccountOfCurrentUser || {}).updatable || false;
          return acc;
        },
        {}
      );
    },

    // レポートが編集可能なフォームを含むかどうか
    // NOTE: 船舶の権限と組み合わせる必要がある
    hasStatusFormAccountUpdatable: (
      _state,
      { statusFormAccountUpdatableMapByOperationWorkflowFormId }
    ) => {
      return Object.keys(
        statusFormAccountUpdatableMapByOperationWorkflowFormId
      ).reduce((acc, key) => {
        const updatable =
          statusFormAccountUpdatableMapByOperationWorkflowFormId[key];
        return acc || updatable === true;
      }, false);
    },

    // NOTE: レポート全体の編集権限
    // レポートのフォームのうち、一つでも編集権限があるか + 船舶の編集権限があるか
    isReportUpdatable(_, { hasStatusFormAccountUpdatable, vesselUpdatable }) {
      return hasStatusFormAccountUpdatable && vesselUpdatable;
    },

    // NOTE: レポートのフォームに編集権限があるか + 船舶の編集権限があるか
    // { [key: operationWorkflowFormId]: boolean }
    reportFormUpdatableMapByOperationWorkflowFormId(
      _,
      {
        statusFormAccountUpdatableMapByOperationWorkflowFormId,
        vesselUpdatable,
      }
    ) {
      const result = Object.keys(
        statusFormAccountUpdatableMapByOperationWorkflowFormId
      ).reduce((acc, operationWorkflowFormId) => {
        acc[operationWorkflowFormId] =
          statusFormAccountUpdatableMapByOperationWorkflowFormId[
            operationWorkflowFormId
          ] && vesselUpdatable;
        return acc;
      }, {});
      return result;
    },

    // 入力可能な必須項目が入力ずみか、nullableCheckedがチェックされているかどうか
    isRequiredFieldsFilled: (_state, getters) => {
      const updatableRecords = getters.reportOperationWorkflowForms
        .filter(operationWorkflowForm => {
          const updatable =
            getters.reportFormUpdatableMapByOperationWorkflowFormId[
              operationWorkflowForm.id
            ];
          return updatable; // 更新権限があるか
        })
        .map(operationWorkflowForm => {
          const enterpriseForm =
            getters.reportEnterpriseFormMap[operationWorkflowForm.form_id];
          const enterpriseFormVersion = enterpriseForm.form_versions.find(
            formVersion =>
              getters.reportFormVersionMapByFormVersionId[formVersion.id]
          );
          const reportFormVersion =
            getters.reportFormVersionMapByFormVersionId[
              enterpriseFormVersion.id
            ];
          return {
            enterpriseFormVersion,
            reportFormVersion,
          };
        });

      const hasNoUpdatableRecords = updatableRecords.length === 0;
      if (hasNoUpdatableRecords) return true; // 編集可能な項目がない場合はtrue

      const enterpriseFormVersions = updatableRecords
        .filter(({ enterpriseFormVersion }) => enterpriseFormVersion)
        .map(({ enterpriseFormVersion }) => enterpriseFormVersion);
      const requiredFormVersionItems = enterpriseFormVersions
        .map(({ form_version_items, id: formVersionId }) => {
          return form_version_items
            .filter(formVersionItem => formVersionItem.required)
            .map(formVersionItem => {
              return { ...formVersionItem, formVersionId };
            });
        })
        .flat();
      const reportMapByItemIdGroupByVersionId = updatableRecords
        .filter(({ reportFormVersion }) => reportFormVersion)
        .reduce((acc, { reportFormVersion }) => {
          const {
            form_version_id,
            ao_enterprise_vessel_report_form_version_items,
          } = reportFormVersion;
          acc[form_version_id] = mapKeys(
            ao_enterprise_vessel_report_form_version_items,
            "form_version_item_id"
          );
          return acc;
        }, {}); // {[key: FormVersionId]: {[key: FormVersionItemId]: reportFormVersionItem}}

      const filledStatusList = requiredFormVersionItems.map(fvi => {
        const reportMapByItemId =
          reportMapByItemIdGroupByVersionId[fvi.formVersionId] || {};
        const reportFormVersionItem = reportMapByItemId[fvi.id] || {};
        const hasValue = operationReportService.hasReportFormVersionItemValue(
          reportFormVersionItem
        ); // 入力値がある
        const isNullableChecked = operationReportService.isNullableChecked(
          reportFormVersionItem
        ); // nullableChecked
        const isFilled = hasValue || isNullableChecked;
        return isFilled;
      });
      const isRequiredFieldsFilled = filledStatusList.reduce(
        (acc, isFilled) => acc && isFilled,
        true
      );
      return isRequiredFieldsFilled;
    },

    // レポートに紐づくフォームバージョン
    // NOTE: こっちはデータ
    reportFormVersions: (
      _,
      { operationReport, isEnterpriseVesselReportValid }
    ) => {
      if (!isEnterpriseVesselReportValid) return [];
      return operationReport.ao_enterprise_vessel_report_form_versions || [];
    },

    // NOTE: 重複する可能性があるため、引けなさそうだが、ひとつのレポートの中では、form_version_id で一意になる
    reportFormVersionMapByFormVersionId: (_state, { reportFormVersions }) => {
      return mapKeys(reportFormVersions, "form_version_id");
    },

    // defaultValueId から reportFormVersionItem を取得するために使う
    reportFormVersionItemMapByFormVersionItemId: (
      _state,
      { reportFormVersions }
    ) => {
      const reportFormVersionItems = reportFormVersions
        .map(rfv => rfv.ao_enterprise_vessel_report_form_version_items)
        .flat();
      return mapKeys(reportFormVersionItems, "form_version_item_id"); // 同一のreportの中ではform_version_item_idで一意になる
    },

    // レポートの各フォームバージョンに紐づくフォームのマスタデータ
    // EnterpriseForms[]
    reportEnterpriseForms: (
      _state,
      { reportFormVersions },
      _rootState,
      rootGetters
    ) => {
      return reportFormVersions.map(
        ({ form_version_id }) =>
          rootGetters["enterpriseForms/enterpriseFormMapByFormVersionId"][
            form_version_id
          ]
      ); // enterpriseForm[]
    },

    reportEnterpriseFormMap: (
      _state,
      { reportEnterpriseForms },
      _rootState,
      _rootGetters
    ) => {
      return mapKeys(reportEnterpriseForms, "id");
    },

    // 現在のstatusに紐づくworkflowTransaction[]
    // is_progress: true なら、進めることができる/falseなら、引き戻しとか
    // source_workflow_status_id が現在のステータス
    // source_workflow_global=true
    // && target_workflow_status_id が1と一致しない
    reportCurrentWorkflowStatusTransactions: (
      _state,
      getters,
      _rootState,
      _rootGetters
    ) => {
      const g = getters;
      return g.reportWorkflowTransactions.filter(transaction =>
        enterpriseWorkflowService.hasAssociationBetweenStatusAndTransaction(
          g.reportWorkflowStatus,
          transaction
        )
      );
    },

    // NOTE: ログインユーザが実行権限をもつトランザクションのマスタのリスト
    // この時点では必須項目の入力値などは考慮していない
    // EnterpriseWorkflowTransaction[]
    executableWorkflowStatusTransactions: (
      _state,
      getters,
      _rootState,
      _rootGetters
    ) => {
      if (!getters.vesselUpdatable) return [];
      const g = getters;
      return g.reportCurrentWorkflowStatusTransactions.filter(
        transaction =>
          g
            .reportCurrentStatusOperationWorkflowTransactionPermissionMapByWorkflowTransactionId[
            transaction.id
          ]
      );
    },
  },
};
